<div 
  class="juvo-dialog-wrapper"
  [ngClass]="[
    'modal-type-' + type, 
    'title-type-' + titleType,
    isStandaloneOverlay ? 'is-overlay' : 'is-in-modal'
  ]"
  (click)="isStandaloneOverlay && showCloseIcon ? handleCancel() : null"
>
  <div class="juvo-dialog-card" (click)="$event.stopPropagation()">
    
    <!-- Botón X -->
    <div *ngIf="showCloseIcon" class="close-icon" (click)="handleCancel()">
      <app-icon iconName="x"></app-icon>
    </div>
    
    <!-- Encabezado del modal -->
    <div *ngIf="title && showTitle" class="juvo-dialog-header" [ngClass]="['title-align-' + titleAlign, 'header-' + titleType]">
      <h2 class="dialog-title">{{ title }}</h2>
    </div>

    <!-- Contenido Principal -->
    <app-scroll-container class="juvo-dialog-body" direction="vertical" size="auto" [showScrollable]="true">
      <p *ngIf="message" class="dialog-message">{{ message }}</p>
      <ng-content *ngIf="!message"></ng-content>
    </app-scroll-container>

    <!-- Pie del modal -->
    <div *ngIf="showFooter" class="juvo-dialog-footer">
      
      <app-button
        *ngIf="showThird"
        [text]="thirdText || ''"
        type="button-outline"
        (buttonClicked)="handleThird()"
      ></app-button>

      <app-button
        *ngIf="showCancel"
        [text]="cancelText || translations['cancel'] || 'Cancel'"
        type="button-outline"
        (buttonClicked)="handleCancel()"
      ></app-button>

      <app-button
        *ngIf="showConfirm"
        [text]="confirmText || translations['ok'] || 'Confirm'"
        type="button-primary"
        [icon]="confirmIcon"
        [disabled]="confirmDisabled"
        (buttonClicked)="handleConfirm()"
      ></app-button>

    </div>

    <!-- Barra inferior coloreada dinámicamente -->
    <div *ngIf="showBottomBar" class="juvo-dialog-bottom-bar"></div>
  </div>
</div>